// Footer component
import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/*const handleLanguageChange = (event) => {
    const language = event.target.value;
    if (language === 'gr') {
        window.location.href = '/gr'; // Greek version
    } else {
        window.location.href = '/'; // English version
    }
};*/

const Footer = () => {
    return (
        <footer className="footer">
            <Container className="footer-container">
                <div className="footer-col">
                    <h4>𝒟𝒾𝑔𝒾𝓉𝒶𝓁 𝒲𝒶𝓇𝒹𝓇𝑜𝒷𝑒</h4>
                    <ul>
                        <li><Link to="/about-us">About Us</Link></li>
                        <li><a href="/our-services">Our Services</a></li>
                        <li><a href="/privacy-policy">Privacy Policy</a></li>
                        <li><a href="/terms-and-conditions">Terms & Conditions</a></li>
                        <li><a href="/user-agreement">User Agreement</a></li>
                    </ul>
                </div>
                <div className="footer-col">
                    <h4>𝒢𝑒𝓉 𝐻𝑒𝓁𝓅</h4>
                    <ul>
                        <li><a href="/how-it-works">How It Works</a></li>
                        <li><a href="/help-center">Help Center</a></li>
                        <li><a href="/frequently-asked-questions">FAQ</a></li>
                        <li><a href="/contact-us">Contact Us</a></li>
                    </ul>
                </div>
                <div className="footer-col">
                    <h4>𝒮𝓉𝒶𝓎 𝒰𝓅𝒹𝒶𝓉𝑒𝒹</h4>
                    <p className="stay-updated-text">Sign up for our newsletter to get the latest updates and enhancements on the web-app!</p>
                    <div className="email-subscribe-container">
                        <input type="email" placeholder="Enter your email" />
                        <button>Subscribe</button>
                    </div>
                </div>
                <div className="footer-col">
                    <h4>𝐹𝑜𝓁𝓁𝑜𝓌 𝒰𝓈 𝒪𝓃:</h4>
                    <div className="social-links">
                        <a href="https://www.facebook.com/profile.php?id=100013363719227" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-facebook-f fa-spin"></i>
                        </a>
                        <a href="https://x.com/p2019034" aria-label="Twitter - X" target="_blank" rel="noopener noreferrer">
                            <i class="fa-brands fa-x-twitter fa-spin"></i>
                        </a>
                        <a href="https://www.instagram.com/j.totheother.j" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-instagram fa-spin"></i>
                        </a>
                    </div>
                </div>
            </Container>
            <div className="footer-bottom">
                <p>Copyright&copy; 2024 Digital Wardrobe. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;

/*<div className="footer-col">
    <h4>𝐿𝒶𝓃𝑔𝓊𝒶𝑔𝑒</h4>
    <select id="language-selector" onChange={handleLanguageChange}>
        <option value="en">English</option>
        <option value="gr">Ελληνικά (Greek)</option>
    </select>
</div>*/